import {
	Component,
	OnInit,
	HostBinding,
	OnDestroy,
	ElementRef,
	AfterViewInit,
	ChangeDetectionStrategy
} from '@angular/core';
import { LayoutConfigService } from '../../../../../core/services/layout-config.service';
import * as objectPath from 'object-path';
import {interval, Subscription} from 'rxjs';
import { QuickSearchDirective } from '../../../../../core/directives/quick-search.directive';
import { QuickSearchService } from '../../../../../core/services/quick-search.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MensagensService } from 'max-ng-lib';
import { SolicitacaoService } from '../../../../../services/solicitacao.service';


@Component({
	selector: 'm-autorizacao-dropdown',
	templateUrl: './autorizacao-dropdown.component.html',
	styleUrls: ['./autorizacao-dropdown.component.scss'],
	changeDetection: ChangeDetectionStrategy.Default
})
export class AutorizacaoDropdownComponent
	implements OnInit, OnDestroy, AfterViewInit {
	onSearch: Subscription;
	@HostBinding('class') classes = '';
	@HostBinding('id') id = 'm_quicksearch';
	@HostBinding('attr.m-dropdown-toggle') attrDropdownToggle = 'click';
	@HostBinding('attr.m-dropdown-persistent') attrDropdownPersistent = '1';
	@HostBinding('attr.m-quicksearch-mode') attrQuicksearchMode = 'dropdown';

	/**
	 * Hack way to call directive programatically for the host
	 * https://stackoverflow.com/questions/41298168/how-to-dynamically-add-a-directive
	 * The official feature support is still pending
	 * https://github.com/angular/angular/issues/8785
	 */
	@HostBinding('attr.mQuickSearch')
	mQuickSearchDirective: QuickSearchDirective;

	notificacoes = [];
	naoLidas = 0;
	tempoDecorrido: number = 0;
	intervaloAtualizacao: Subscription;
	tempoFixoAtualizacao: number = 3;


	constructor(
		public mensagemService: MensagensService,
		private router: Router,
		private layoutConfigService: LayoutConfigService,
		private el: ElementRef,
		private quickSearchService: QuickSearchService,
		private  solicitacaoService: SolicitacaoService,
		public routerActivated: ActivatedRoute
	) {
		this.id = this.routerActivated.snapshot.paramMap.get('id');
		this.ativarListenerClass();
	}

	ngOnInit(): void {
		this.carregarNotificacoesAutorizacao();
		this.ativarAtualizacaoAutomatica();
		this.routerActivated.queryParams.subscribe(params => {
			if (params['reload']) {
				this.carregarNotificacoesAutorizacao();
			}
		});
	}

	ativarListenerClass(){
		this.layoutConfigService.onLayoutConfigUpdated$.subscribe(model => {
			const config = model.config;

			this.classes =
				'm-nav__item m-dropdown m-dropdown--large m-dropdown--arrow m-dropdown--align-center m-dropdown--mobile-full-width m-dropdown--skin-light m-list-search m-list-search--skin-light';

			this.classes +=
				' m-dropdown--skin-' +
				objectPath.get(config, 'header.search.dropdown.skin');
		});
	}

	carregarNotificacoesAutorizacao() {
		this.solicitacaoService.solicitacaoCheckinForaRaioAtivo()
		.subscribe((itens: any) => {
			this.notificacoes = JSON.parse(JSON.stringify(itens)).map(item => {
				return{
					id: item.id,
					idRegistro: item.id,
					tipo: item.tipo,
					descricaoTipo: item.descricaoTipo,
					lida: 'NAO',
					mensagem: item.fantasia
				};
			});
			this.naoLidas = this.notificacoes.filter(m => m.lida === 'NAO').length;
      	});
	}

	ngOnDestroy() {
		this.onSearch.unsubscribe();
		if (this.intervaloAtualizacao) {
			this.intervaloAtualizacao.unsubscribe();
		}
	}

	ngAfterViewInit(): void {
		Promise.resolve(null).then(() => {
			this.mQuickSearchDirective = new QuickSearchDirective(this.el);
			this.mQuickSearchDirective.ngAfterViewInit();

			// listen to search event
			this.onSearch = this.mQuickSearchDirective.onSearch$.subscribe(
				(mQuickSearch: any) => {
					mQuickSearch.showProgress();
					this.quickSearchService.search().subscribe(result => {
						// append search result
						mQuickSearch.showResult(result[0]);
						mQuickSearch.hideProgress();
					});
				}
			);
		});
	}

	verTodas() {
		this.router.navigateByUrl('/pages/autorizacoes/autorizacao-checkin-fora-raio');
	}

	tipoNotificacao = (value) => {
		let classeTipoNotificacao;
		switch (value.tipo) {
			case 'CK_FORA_RAIO': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/checkin.png';
				break;
			case 'CNH': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/bateria.png';
				break;
			case 'EVENTO': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/evento.png';
				break;
			case 'TEMPO_ESPERA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/em espera.png';
				break;
			case 'TEMPO_ENTREGA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/entrega inferior a 2 min.png';
				break;
			case 'BATERIA_FRACA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/bateria.png';
				break;
			case 'RETORNO_VIAGEM': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/retorno_viagem.png';
				break;
			case 'TEMPO_ENTRE_CLIENTES': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/bateria.png';
				break;
			case 'FILA_ESPERA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/em espera.png';
				break;
			case 'DEVOLUCAO': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/devolução.png';
				break;
			case 'FURO_DE_SEQUENCIA_ENTREGA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/bateria.png';
				break;
			case 'ENTREGA_INFERIOR_2_MIN': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/entrega inferior a 2 min.png';
				break;
			case 'ECONOMIA_BATERIA': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/economia_bateria.png';
				break;
			case 'GPS_DESLIGADO': classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/gps_desligado.png';
				break;
			default: classeTipoNotificacao = '../../../../../../assets/app/media/img/icons/icons-notificacoes/bateria.png';
		}
		return classeTipoNotificacao;
	}

	detalhes(notificacao) {
		this.router.navigate(['/pages/autorizacoes//detalhe-autorizacao-fora/', notificacao.id]);
	}


	ativarAtualizacaoAutomatica() {
		this.intervaloAtualizacao = interval(300000).subscribe(() => {
			this.tempoDecorrido++;
			if (this.tempoDecorrido % this.tempoFixoAtualizacao === 0) {
				this.carregarNotificacoesAutorizacao();
			}
		});
	}
}
